module.exports = [{
	name: 'index',
	path: './src/index',
	templatename: 'VENOM-DEMO',
	template: './src/example/index.ejs'
},{
	name: 'roulette',
	path: './src/games/Roulette/index.js',
	templatename: '大转盘',
	template: './src/example/roulette.ejs'
},{
	name: 'boxroulette',
	path: './src/games/BoxRoulette/index.js',
	templatename: '九宫格',
	template: './src/example/boxroulette.ejs'
},{
	name: 'flipcard',
	path: './src/games/FlipCard/index.js',
	templatename: '翻牌',
	template: './src/example/flipcard.ejs'
},{
	name: 'dice',
	path: './src/games/Dice/index.js',
	templatename: '掷骰子',
	template: './src/example/dice.ejs'
},{
	name: 'slotmachine',
	path: './src/games/SlotMachine/index.js',
	templatename: '老虎机',
	template: './src/example/slotmachine.ejs'
},{
	name: 'redenvelope',
	path: './src/games/RedEnvelope/index.js',
	templatename: '拆红包',
	template: './src/example/redenvelope.ejs'
}];
